__turbopack_context__.v({
  "layout": "index-module__V3Tmdq__layout",
  "title": "index-module__V3Tmdq__title",
  "widget": "index-module__V3Tmdq__widget",
  "wrapper": "index-module__V3Tmdq__wrapper",
});
